import type { InjectionKey, Ref } from "vue";
import type { MenuItemKeys, MenuKeys } from "./menus";

export const keys = {
    isLoadingVisible: Symbol("isLoadingVisible") as InjectionKey<Ref<boolean, boolean>>,
    activeMenu: Symbol("activeMenu") as InjectionKey<Ref<Record<MenuKeys, boolean>>>,
    activeMenuItem: Symbol("activeMenuItem") as InjectionKey<Ref<MenuItemKeys | undefined>>,
};
